





import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { store } from '@/modules/servis/zakazka/store/edit';

import { SAGA_2_KOM } from '../constants';

export default Vue.extend({
	name: 'Saga2Komunikace',
	props: {
		storeUri: { type: String, required: true },
	},
	data() {
		return {
			SAGA_2_KOM,
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
});
